import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const MailArrowIcon = (props: IconProps) => (
  <Icon width="14px" height="14px" viewBox="0 0 14 14" {...props}>
    <path d="M12 .666626H1.33333C.6.666626 0 1.26663 0 1.99996v8c0 .73334.6 1.33334 1.33333 1.33334h6V9.99996h-6V3.33329l5.33334 3.33334L12 3.33329v3.33334h1.3333V1.99996c0-.73333-.6-1.333334-1.3333-1.333334ZM6.66667 5.33329 1.33333 1.99996H12L6.66667 5.33329Zm4.66663 2.66667L14 10.6666l-2.6667 2.6667v-2H8.66667V9.99996h2.66663v-2Z" />
  </Icon>
);

export default memo(MailArrowIcon);
